import { Container, i18n, Table, TableRow, utils } from "@common";
import { useRef, useCallback, useState, useMemo, useEffect } from 'react';
import { StaffScheduleIntervalI18N } from "../../../constant";
import { adminService } from "@api";
import Schedule from "./schedule";
import excelIMG from "@image/excel.png";
import "./index.less";

const StaffAcessReviews = () => {
    const tableRef = useRef();
    const [selectedItems, setSelectedItems] = useState([]);
    const [showSchedule, setShowSchedule] = useState({ show: false });
    const [isShowscheduleInfo, setIsShowscheduleInfo] = useState(true);
    const [scheduleInfo, setScheduleInfo] = useState({
        Interval: null,
        StartDate: null,
        EndDate: null
    });

    const filter = {
        search: { id: 'search-staff-access-review', placeholder: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Search_Entry') },
    };

    useEffect(() => {
        getScheduleInfo();
    }, []);

    const doDownload = useCallback((selectedItems) => {
        const reportNameArr = selectedItems?.map((el) => el.fileName);
        const timeZone = new Date().getTimezoneOffset() / -60;
        $$.loading(true);
        adminService.staffAcessDownload({ filename: reportNameArr, timeZone }).then(() => {
            return true;
        }).catch((e) => {
            $$.loading(false);
            $$.toast(i18n.get('CIS_Admin_Common_DownLoadFailed_Message'), 'error');
        }).finally(() => {
            $$.loading(false);
        });
    }, []);

    const doRunNow = () => {
        const timeZone = new Date().getTimezoneOffset() / -60;
        const lastSevenDays = '0';
        const defafultFilter = { filters: { Date: [lastSevenDays] }, timeZone };
        $$.loading(true);
        adminService.staffAcessCreateRunNow(defafultFilter).then(() => {
            $$.toast(i18n.get('CIS_Admin_Reporting_StaffAccessReview_RunNowSucess_Message'), 'success');
        }).catch((e) => {
            $$.loading(false);
            $$.toast(i18n.get('CIS_Admin_Reporting_StaffAccessReview_RunNowFaild_Message'), 'error');
        }).finally(() => {
            $$.loading(false);
        });
    };

    const doSchedule = () => {
        setShowSchedule({ show: true });
    };

    const doRefresh = () => {
        reloadTable(true, i18n.get('CIS_Admin_Common_RefreshSucceeded_Message'), false);
    };

    const reloadTable = useCallback((create, message, isGetScheduleInfo) => {
        create ?
            tableRef.current.loadFirstPage() :
            tableRef.current.loadCurrentPage();
        setShowSchedule({ show: false });
        if (message) {
            $$.toast(message);
        }
        if (isGetScheduleInfo) {
            getScheduleInfo();
        }
    }, [tableRef]);

    const { isDownLoadDisabled } = useMemo(() => {
        const isDownLoadDisabled = selectedItems?.length < 1;
        return { isDownLoadDisabled };
    }, [selectedItems]);

    const buttons = [
        {
            id: "btn-staff-access-review-download",
            type: 'bald',
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            icon: 'fia-download',
            disabled: isDownLoadDisabled,
            classify: 'info',
            onClick: () => doDownload(selectedItems)
        },
        {
            id: "btn-staff-access-review-resetPassword",
            type: 'bald',
            text: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Schedule_Entry'),
            icon: 'fia-config',
            onClick: () => doSchedule()
        },
        {
            id: "btn-staff-access-review-runNow",
            type: 'bald',
            text: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Filter_Button_Entry'),
            icon: 'fia-arrow-circle-right',
            onClick: () => doRunNow()
        },
        {
            id: "btn-staff-access-review-resetFA",
            type: 'bald',
            text: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Refresh_Entry'),
            icon: 'fia-refresh',
            onClick: () => doRefresh()
        },
    ];

    const columns = [
        { header: i18n.get('CIS_Admin_Reporting_StaffAccessReview_ReportName_Entry'), sortable: true, valuePath: 'filename', with: ['220px'] },
        { header: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Size_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_StaffAccessReview_GenerateDate_Entry'), sortable: -1, valuePath: 'generatedate' },
    ];

    const onRowEvent = (args) => {
        let rowData = args.rowData;
        switch (args.type) {
            case "download":
                onDownLoad(rowData);
                break;
        }
    };

    const onDownLoad = (rowData) => {
        const reportName = [rowData?.fileName];
        const timeZone = new Date().getTimezoneOffset() / -60;
        adminService.staffAcessDownload({ filename: reportName, timeZone }).then(() => {
            $$.loading(false);
            return true;
        });
    };

    const onLoadData = useCallback((info) => {
        const infoData = { ...info };
        delete infoData.filters;
        if (!infoData.searchContent) {
            infoData.searchContent = '';
        }
        if (!infoData.sortKey) {
            infoData.sortKey = '';
        }
        return adminService.staffAcessAllPaging(infoData);
    }, []);

    const onCheck = useCallback(selectedItems => {
        setSelectedItems(selectedItems);
    }, [setSelectedItems]);

    const getScheduleInfo = () => {
        setIsShowscheduleInfo(false);
        adminService.staffAcessFindSchedulerRules().then((res) => {
            const data = res?.items;
            if (data?.interval && data?.startDate) {
                setIsShowscheduleInfo(true);
                setScheduleInfo({
                    Interval: data?.interval,
                    StartDate: utils.formatDateTime(data?.startDate),
                    EndDate: utils.formatDateTime(data?.endDate)
                });
            } else {
                setIsShowscheduleInfo(false);
            }
        });
    };

    return (
        <Container className={"staffAcessReview"}>
            <div className="topBox">
                <div className="scheduleBox">
                    {isShowscheduleInfo ?
                        <>
                            <span className="schedule">
                                {i18n.get('CIS_Admin_Reporting_StaffAccessReview_Filter_Schedule_Entry')}
                            </span>
                            <span className="content">
                                {i18n.get('CIS_Admin_Reporting_StaffAccessReview_Filter_ScheduleD_Entry', StaffScheduleIntervalI18N[scheduleInfo?.Interval], scheduleInfo?.StartDate)}
                            </span>
                            <span className="content">
                                {i18n.get('CIS_Admin_Common_dateSuffix_Entry')}
                            </span>
                            {scheduleInfo?.EndDate ?
                                <span className="content">
                                    {i18n.get('CIS_Admin_Reporting_StaffAccessReview_Filter_ScheduleDTo_Entry', scheduleInfo?.EndDate)}
                                    {i18n.get('CIS_Admin_Common_dateSuffix_Point_Entry')}
                                </span>
                                : "."
                            }
                        </>
                        :
                        i18n.get('CIS_Admin_Reporting_StaffAccessReview_Filter_NoneScheduled_Entry')
                    }
                </div>
            </div>
            <Table
                id="table-staff-access-review"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                buttons={buttons}
                filter={filter}
                checkable
                onCheck={onCheck}
                onRowEvent={onRowEvent}
                sort={{ name: 'generatedate', status: 'desc' }}
            />
            <Schedule status={showSchedule} reloadTable={reloadTable} />
        </Container>
    );
};
class TableRowTemp extends TableRow {
    downloadClick = () => this.dispatch('download');
    action = () => {
        return [{
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            icon: 'fia-download',
            name: 'download',
            tooltip: i18n.get('CIS_Admin_Common_Download_Entry'),
            onClick: this.downloadClick
        }];
    };
    render(Row, Cell) {
        const { fileName, fileSize, generateDate } = this.props.rowData;
        return (
            <Row action={this.action}>
                <Cell> <ViewFileExcel text={fileName} /></Cell>
                <Cell>{utils.fixFloat(fileSize / 1024, 2) || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{utils.formatDateTime(generateDate) || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

const ViewFileExcel = props => {
    const { text } = props;
    return (
        <>
            <div className="fileBox">
                <img className="img" src={excelIMG} alt="" />
                <div className="text">{text}</div>
            </div>
        </>);
};

export default StaffAcessReviews;


